<template>
  <div id="storeInspectionManage">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
              <el-form-item :label="$t('storeInspection.storeId')">
                <el-input v-model="filterForm.itemId" :placeholder="$t('storeInspection.enterId')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('storeInspection.storeType')" >
                <el-select v-model="filterForm.type" :placeholder="$t('storeInspection.chooseType')">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('storeInspection.chanceDesc')">
                <el-input v-model="filterForm.content" :placeholder="$t('storeInspection.search')"></el-input>
              </el-form-item>

              <el-form-item :label="$t('survey.status')" >
                <el-select v-model="filterForm.status" :placeholder="$t('interaction.chooseStatus')">
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('storeInspection.inspectionDate')" >
                <el-date-picker
                  v-model="filterForm.dateRange"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                  align="right">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('filters.doorName')" >
                <span @click="onChooseDoor">
                  <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
                </span>
              </el-form-item>
              <el-form-item label="门店编号">
                <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
              </el-form-item>

              <el-form-item :label="$t('filters.reseller')" >
                <el-select v-model="filterForm.resellerNos" multiple :placeholder="$t('filters.chooseReseller')" >
                  <el-option
                    v-for="item in resellerOptions"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="24">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
            <p class="operations">
              <el-button type="primary" style="margin-right: 50px" @click="addStore()">{{ $t('storeInspection.addStore') }}</el-button>

              <el-button type="primary" @click="$refs.importFile.click()">{{ $t('storeInspection.importDoor') }}</el-button>
              <input type="file" ref="importFile" @change="importExcel" v-show="false"/>

              <el-button type="text" style="margin-left: 10px" @click="downloadTemplate"><i
                class="el-icon-info"></i>{{ $t('store.downloadTemplate') }}</el-button>
              <el-button type="plain" style="margin-left: 50px" @click="updateStatus(-1)">{{ $t('storeInspection.update') }}</el-button>
              <el-button type="primary" style="margin-left: 50px" @click="exportData()">{{ $t('storeInspection.export') }}</el-button>
              <el-button type="primary" @click="exportImage()">{{ $t('storeInspection.exportImage') }}</el-button>
              <el-button type="text" style="margin-left: 20px" @click="openBookingList">{{ $t('exportBookings') }}</el-button>
            </p>
          </div>
          <div class="chooseAll">
            <el-checkbox v-model="chooseAll" @change="selectAllCurrentPage">分页全选</el-checkbox>
          </div>
          <div style="margin-top: 20px">
            <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                fixed
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                fixed
                prop="itemId"
                :label="$t('storeInspection.storeId')"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="typeName"
                :label="$t('storeInspection.storeType')"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="content"
                :label="$t('storeInspection.chanceDesc')"
                width="300"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="statusName"
                :label="$t('survey.status')"
                width="100"
              >
              </el-table-column>
              <el-table-column
                prop="createDate"
                :label="$t('storeInspection.inspectionDate')"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="posId"
                label="门店编号">
              </el-table-column>
              <el-table-column
                prop="doorName"
                :label="$t('filters.doorName')"
                width="270"
              >
              </el-table-column>
              <el-table-column
                prop="resellerName"
                :label="$t('filters.reseller')"
              >
              </el-table-column>

              <el-table-column
                fixed="right"
                :label="$t('operation')"
                width="280"
              >
                <template slot-scope="scope">
                  <router-link v-if="scope.row.status===1" :to=" { path:'/storeInspection/storeInspectionEdit', query:{ id: scope.row.itemId} }" target="_blank" style="margin-right: 12px">
                    <el-button type="text" size="small">{{ $t('edit') }}</el-button>
                  </router-link>
                  <!-- <el-button @click="openDetail(scope.row.itemId)" type="text" size="small">{{ $t('storeInspection.storeDetail') }}</el-button> -->
                  <router-link v-if="scope.row.status!=1" :to=" { path:'/storeInspection/storeInspectionDetail', query:{ id: scope.row.itemId} }" target="_blank" style="margin-right: 12px">
                    <el-button type="text" size="small">{{ $t('storeInspection.storeDetail') }}</el-button>
                  </router-link>
                  <el-button @click="updateStatus(scope.row.itemId)" type="text" size="small">{{ $t('storeInspection.update') }}</el-button>
                  <!-- <el-button @click="openStoreInfo(scope.row.itemId)" type="text" size="small">{{ $t('storeInspection.storeInfo') }}</el-button> -->
                  <router-link :to=" { path:'/topdoor/storeEdit', query:{ doorNo: scope.row.doorNo} }" target="_blank" >
                    <el-button type="text" size="small">{{ $t('storeInspection.storeInfo') }}</el-button>
                  </router-link>
                  <el-button @click="onDelete(scope.row.itemId)" type="text" size="small">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :title="$t('storeInspection.update')"
      :visible.sync="updateDialogVisible"
      width="40%"
      center
    >
      <div class="centerBox">
        <el-radio-group v-model="newStatus">
          <el-radio :label="2" border>待处理</el-radio>
          <el-radio :label="3" border>处理中</el-radio>
          <el-radio :label="4" border>已完成</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmUpdate">{{ $t('confirm') }}</el-button>
        <el-button type="plain" @click="updateDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('storeInspection.export')" :visible.sync="exportDialogVisible" width="40%" center>
      <el-form :model="exportForm" label-width="75px">
        <slot name="type"></slot>
        <el-form-item :label="$t('storeInspection.exportType')">
          <el-radio-group v-model="exportForm.type">
            <el-radio :label="1">{{ $t('storeInspection.immediate') }}</el-radio>
            <el-radio :label="2">{{ $t('storeInspection.bookExport') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('storeInspection.bookExport')" v-if="exportForm.type === 2">
          <el-date-picker
            style="width: 215px"
            v-model="exportForm.time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('choose')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmExport">{{ $t('confirm') }}</el-button>
          <el-button type="plain" @click="exportDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
      <slot name="list"></slot>
    </el-dialog>
    <el-dialog :title="$t('storeInspection.exportStoreImage')" :visible.sync="exportImageDialogVisible" width="40%" center>
      <el-form :model="exportImageForm" label-width="75px">
        <slot name="type"></slot>
        <el-form-item :label="$t('storeInspection.exportType')">
          <el-radio-group v-model="exportImageForm.type">
            <el-radio :label="1">{{ $t('storeInspection.immediate') }}</el-radio>
            <el-radio :label="2">{{ $t('storeInspection.bookExport') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('storeInspection.bookExport')" v-if="exportImageForm.type === 2">
          <el-date-picker
            style="width: 215px"
            v-model="exportImageForm.time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('choose')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmImageExport">{{ $t('confirm') }}</el-button>
          <el-button type="plain" @click="exportImageDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
      <slot name="list"></slot>
    </el-dialog>
    <el-dialog
      :title="$t('exportBookings')"
      :visible.sync="downloadDialog"
      width="60%"
      center>
      <div class="downloadList">
        <el-table :data="downloadList">
          <el-table-column property="id" :label="$t('sort')" ></el-table-column>
          <el-table-column property="dataTypeName" :label="$t('storeInspection.exportType')"></el-table-column>
          <el-table-column property="name" :label="$t('storeInspection.exportName')"></el-table-column>
          <el-table-column property="condition" :label="$t('storeInspection.exportCondition')" ></el-table-column>
          <el-table-column property="status" :label="$t('survey.status')" ></el-table-column>
          <el-table-column :label="$t('operation')" width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 'ok'"
                type="text"
                size="mini"
                @click="downloadData(scope.row.urls)"
              >{{ $t('download') }}</el-button>
              <span v-if="scope.row.status !== 'ok'">{{ $t('processing') }}</span>
              <el-button
                type="text"
                size="mini"
                @click="deleteData(scope.row.id)"
              >{{ $t('delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <footer>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="downloadCurrentChange"
            :current-page="downloadTableConfig.current"
            :total="downloadTotal"
          ></el-pagination>
        </footer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialog = false">{{ $t('close') }}</el-button>
      </span>
    </el-dialog>
    <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
  </div>
</template>

<script>
import _ from 'lodash'
import PickDoor from "../../components/pickTopDoor";

export default {
  name: 'TaskManage',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      updateDialogVisible: false, //更新状态弹窗
      exportDialogVisible: false, //导出数据弹窗
      exportImageDialogVisible: false, //导出图片弹窗
      downloadDialog: false, //预约下载列表
      chooseAll: false, //分页全选
      currentId: '', //当前操作项id
      systemOptions: [
      ],
      //状态(1:创建中 2:待处理 3:处理中 4:已完成)
      statusOptions: [
        {
          itemKey: 1,
          itemValue: '创建中'
        },
        {
          itemKey: 2,
          itemValue: '待处理'
        },
        {
          itemKey: 3,
          itemValue: '处理中'
        },
        {
          itemKey: 4,
          itemValue: '已完成'
        },
      ],
      taskListFilterForm: {}, // 任务列表的筛选条件
      initTaskListFilterForm: {
        systemType: '',
        status: ''
      },
      filterForm: {
        storeId: '', //巡店id
        type: '', //巡店类型
        chanceDesc: '', //机会点描述
        status: '', //状态
        dateRange: [], // 巡店时间
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        posId: '',
        doorName: '', //门店名称
        resellerNos: [], //客户
      },
      initFilterForm: {
        storeId: '', //巡店id
        type: '', //巡店类型
        chanceDesc: '', //机会点描述
        status: '', //状态
        dateRange: [], // 巡店时间
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        posId: '',
        doorName: '', //门店名称
        resellerNos: [], //客户
      },
      tableData: [], // 表格数据
      total: 0,
      totalTaskList: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      newStatus: 1, //需要更新的状态
      tableConfigTaskList: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      taskTableLoading: false,
      multipleSelection: [],
      resellerOptions: [
      ],
      //类型(1:assortment产品 2:service服务 3:enviroment环境 4:story telling故事演绎)
      typeOptions: [
        {
          itemKey: 1,
          itemValue: 'assortment产品'
        },
        {
          itemKey: 2,
          itemValue: 'service服务'
        },
        {
          itemKey: 3,
          itemValue: 'enviroment环境'
        },
        {
          itemKey: 4,
          itemValue: 'story telling故事演绎'
        },
      ],
      exportForm: {
        type: 1, //立刻导出or预约导出
        time: '', //预约时间
      },
      exportImageForm: {
        type: 1, //立刻导出or预约导出
        time: '', //预约时间
      },
      initExportForm: {
        type: 1, //立刻导出or预约导出
        time: '', //预约时间
      },
      downloadList: [], //预约下载列表
      downloadTotal: 0, // 下载列表总数量
      downloadTableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
    }
  },
  mounted () {
    this.getRangeList()
    this.onReset()
  },

  methods: {

    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(topdoorReqUrl + '/door/ganged', submitParams)
      console.log('res', res)
      res = res.data.data
      this.resellerOptions = res.resellers
    },

    // 新增巡店
    addStore() {
      const route = this.$router.resolve({
        path: '/storeInspection/storeInspectionEdit',
      })
      window.open(route.href, '_blank')
    },


    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    seeDetail() {
      // todo: 查看
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
      // console.log('....chooseall....', this.chooseAll)
      // this.tableData.forEach(row => {
      //   console.log('....', row.posId)
      //   this.$refs.multipleTable.toggleRowSelection(row, true)
      // })
    },

    // 更新状态
    updateStatus: function(id) {
      this.updateDialogVisible = true
      if(id===-1){
        this.currentId = null
      } else {
        this.currentId = id
      }
      //this.newStatus = 1
    },


    // 导出数据
    exportData: function() {
      this.exportDialogVisible = true
      this.exportForm = _.cloneDeep(this.initExportForm)
    },

    // 导出图片
    exportImage: function() {
      this.exportImageDialogVisible = true
      this.exportImageForm = _.cloneDeep(this.initExportForm)
    },

    // 预约导出列表
    openBookingList: function() {
      this.downloadTable()
      this.downloadDialog = true
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log('.....id....', val)
      // 获取选中项id的方法
      /*const ids = [];
      _.each(this.multipleSelection, (item) => {
        ids.push(item.id);
      });*/
    },

    // 添加全选当前页方法
    selectAllCurrentPage(val) {
      // console.log('xxxxx' ,val)
      // this.tableData.forEach(row => {
      //   this.$refs.multipleTable.toggleRowSelection(row, val)
      // })
    },

    // 确认更新状态
    async confirmUpdate() {
      let param
      let submitParams = this.filterForm
      console.log('submitParams', submitParams)
      submitParams.startTime = submitParams.dateRange ? submitParams.dateRange[0] : ''
      submitParams.endTime = submitParams.dateRange ? submitParams.dateRange[1] : ''
      param = _.assign(submitParams, this.tableConfig)
      if (this.chooseAll) {
        // 全部选中(包括非当前页)
        param.itemIds = [];
        param.selectType = 2  // 2分页全选
      } else {
        param.selectType = 1
        // 获取选中的id集合
        const ids = [];
        if(this.currentId){
          ids.push(this.currentId)
        }else{
          _.each(this.multipleSelection, (item) => {
          ids.push(item.itemId);
        });
        }
        param.itemIds = ids;
      }
      param.newStatus = this.newStatus
      console.log('....修改状态提交参数。。。。', param)
      let res = await window.instance.post(topdoorReqUrl + '/inspection/changeStatus', submitParams)
      console.log('res', res)
      res = res.data
      if(res.code === 200) {
        this.$message.success(res.message)
        this.updateDialogVisible = false
        await this.onSearch()
      }else{
        this.$message.warning(res.message)
      }

    },

    // 确认导出
    async confirmExport() {
      let param
      let submitParams = this.filterForm
      console.log('submitParams', submitParams)
      submitParams.startTime = submitParams.dateRange ? submitParams.dateRange[0] : ''
      submitParams.endTime = submitParams.dateRange ? submitParams.dateRange[1] : ''
      param = _.assign(submitParams, this.tableConfig)
      param.exportType = this.exportForm.type  //导出方式(1:立刻导出 2:预约导出)
      param.exportTime = this.exportForm.time
      param.dataType = 1  //导出类型(1:数据 2:图片)

      if(this.exportForm.type==2 && !this.exportForm.time){
        this.$message.warning("请选择预约时间")
        return
      }

      let res = await window.instance.post(topdoorReqUrl + '/inspection/exportData', param)
      res = res.data
      console.log('res', res.data)
      if(res.code === 200) {
        this.$message.success(res.message)
      }else{
        this.$message.warning(res.message)
      }
    },

    // 确认导出图片
    async confirmImageExport() {
      let param
      let submitParams = this.filterForm
      console.log('submitParams', submitParams)
      submitParams.startTime = submitParams.dateRange ? submitParams.dateRange[0] : ''
      submitParams.endTime = submitParams.dateRange ? submitParams.dateRange[1] : ''
      param = _.assign(submitParams, this.tableConfig)
      param.exportType = this.exportImageForm.type  //导出方式(1:立刻导出 2:预约导出)
      param.exportTime = this.exportImageForm.time
      param.dataType = 2  //导出类型(1:数据 2:图片)

      if(this.exportImageForm.type==2 && !this.exportImageForm.time){
        this.$message.warning("请选择预约时间")
        return
      }

      let res = await window.instance.post(topdoorReqUrl + '/inspection/exportData', param)
      res = res.data
      console.log('res', res.data)
      if(res.code === 200) {
        this.$message.success(res.message)
      }else{
        this.$message.warning(res.message)
      }
    },

    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let submitParams = this.filterForm
      console.log('submitParams', submitParams)
      submitParams.startCreateDate = submitParams.dateRange ? submitParams.dateRange[0] : ''
      submitParams.endCreateDate = submitParams.dateRange ? submitParams.dateRange[1] : ''
      let res = await window.instance.post(topdoorReqUrl + '/inspection/list', _.assign(submitParams, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.inspections
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },

    // 导入巡店记录
    async importExcel({ target }) {
      let formData = new FormData();
      formData.append("file", target.files[0]);
      let res = await window.instance.post(topdoorReqUrl + "/inspection/importInspection", formData);
      if(res.data.code === 200) this.$message.success("导入成功！");
      else this.$message.error("导入失败！");
    },

    // 下载模板
    downloadTemplate: async function () {
      let response = await window.instance({
        method: "post",
        responseType: "blob",
        url: topdoorReqUrl + '/inspection/template',
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },

    // 删除
    onDelete: async function(id){
      const confirmTip = this.$t('topdoor.deleteDoor')+'?'
      const tip = this.$t('tip')
      this.$confirm(confirmTip, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await window.instance.post(topdoorReqUrl + "/inspection/delete/" + id)
          res = res.data
          if (res.code === 200) {
            this.$message.success(res.message)
            await this.onSearch()
          }else{
            this.$message.message(res.message)
          }
        })
        .catch(_ => {
        })
    },

    downloadCurrentChange(index) {
      // 分页
      this.downloadTableConfig.current = index;
      this.downloadTable()
    },

    // 预约下载列表
    async downloadTable() {
      this.downloadDialog = true
      let res = await window.instance.post(topdoorReqUrl + "/inspection/exportList", _.assign({id: this.id}, this.downloadTableConfig));
      if (res.data.code === 200) {
        console.log('res.data', res.data)
        this.downloadList = res.data.data.records
        this.downloadTotal = res.data.data.total
      }
    },

    // 下载具体的文件
    downloadData(urls) {
      _.each(urls, (file) => {
        window.open(file)
      })
    },

    // 删除预约下载
    deleteData(id) {
      const confirmTip = this.$t('confirmDelete')+'?'
      const tip = this.$t('tip')
      this.$confirm(confirmTip, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await window.instance.post(topdoorReqUrl + "inspection/deleteExport/" + id)
          res = res.data
          if (res.code === 200) {
            this.$message.success(res.message)
            await this.downloadTable()
          }
        })
        .catch(_ => {
        })
    }
  }
}
</script>

<style scoped lang="sass">
.operations
  float: right
  color: #ff6801
  font-size: 14px
  margin: -30px 0 0 90px
  span
    margin-right: 20px
#storeInspectionManage
  .chooseAll
    margin-left: 10px
    margin-top: 20px
  .centerBox
    text-align: center

  footer
    padding-top: 20px
    text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/storeInspection/storeInspectionManage.vue